import store from "@/store";
import request from "@/utils/request";

export async function getEventList(params) {
    console.log("@@ get list : getEventList");
    let result = request.get("/api/marketing/event/",{params});
    return result;
}
export async function getEventDetail(params) {
    console.log("@@ get list : getEventDetail");
    let result = request.get("/api/marketing/event/detail/",{params});
    return result;
}

export async function saveEvent(params) {
    console.log("@@ post save : saveEvent");
    let result = request.post(`/api/marketing/event/save/`,params);
    return result;
}

export async function deleteEvent(params) {
    console.log("@@ get list : deleteEvent");
    let result = request.post("/api/marketing/event/delete/",params);
    return result;
}

export async function saveEventPrize(params) {
    console.log("@@ post save : saveEventPrize");
    let result = request.post(`/api/marketing/event/announce/save/`,params);
    return result;
}

export async function deleteEventPrize(params) {
    console.log("@@ delete : deleteEventPrize");
    let result = request.post(`/api/marketing/event/announce/delete/`,params);
    return result;
}

// 등록일 경우 params = {eventSeq, content}, 수정일 경우 params = {seq, content}
export async function saveReplyNotice(params) {
    console.log("@@ post save : saveReplyNotice");
    let result = request.post(`/api/marketing/eventReply/`,params);
    return result;
}

export async function deleteReplyNotice(params) {
    console.log("@@ delete : deleteReplyNotice");
    let result = request.delete(`/api/marketing/eventReply/`, {params});
    return result;
}